import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCarrot, faCogs, faEye, faPenToSquare, faQuestion } from "@fortawesome/free-solid-svg-icons"
import {  useNavigate, useParams } from 'react-router-dom'
import { useGetQuestionSetsQuery } from './questionSetsApiSlice'
import { memo } from 'react'
import useAuth from "../../hooks/useAuth"
import TimeLeft from '../../partial/TimeLeft'
import ReactQuill from 'react-quill';

const QuestionSet = ({ questionSetId }) => {
    const {groupId, type} = useParams()
    const { isTeacher, isAdmin, isStudent } = useAuth()




    const { questionSet } = useGetQuestionSetsQuery("questionSetsList", {
        selectFromResult: ({ data }) => ({
            questionSet: data?.entities[questionSetId]
        }),
    })

    const navigate = useNavigate()
  

    if (questionSet) {
        //const created = new Date(questionSet.createdAt).toLocaleString('en-US', { day: 'numeric', month: 'long' })
         const handleEdit = () => navigate(`/${type}/${groupId}/question-sets/${questionSetId}`)
         const handleGenerate = () => navigate(`/${type}/${groupId}/question-sets/${questionSetId}/final`)
         const cellStatus =''

         let editButton = null
         if(isAdmin|| isTeacher){editButton=(
             <button
             className="icon-button table__button"
             onClick={handleEdit}
         >
             <FontAwesomeIcon icon={faPenToSquare} />
         </button>
         )}
         
   
  
        return (
            <tr className="table__row">
                <td className={`table__cell questionSet__title ${cellStatus}`}>{questionSet.title}</td>
                <td className={`table__cell questionSet__title ${cellStatus}`}>{questionSet.course?.name}</td>
                <td className={`table__cell questionSet__title ${cellStatus}`}>{questionSet.createdByName}</td>
                <td className={`table__cell questionSet__actions ${cellStatus}`} >{questionSet.questions?.length}</td>
                <td className={`table__cell questionSet__title ${cellStatus}`}>
                   <div className='d-flex'>

                    {editButton}
                    <button
             className=" table__button"
             onClick={handleGenerate}
         >
           גרסה למשתמשים <FontAwesomeIcon icon={faCogs} />
         </button>
         </div>   
                </td>
            </tr>
        )

    } else return null
}

const memoizedQuestionSet = memo(QuestionSet)

export default memoizedQuestionSet